// Components
import { FormControl, Select, MenuItem } from '@mui/material';
import { useTranslationContext } from '../../../../context/TranslationContext';

type Props = {
  value: string;
  handleChange: (value: string) => void;
  options: string[];
};

const CustomPropertyOptionsSelect = ({ handleChange, value, options }: Props) => {
  const t = useTranslationContext();

  return (
    <FormControl className="fadein" sx={{ width: '100%' }}>
      <Select
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        size="small"
        variant="standard"
      >
        <MenuItem value="">{t('global.noValue')}</MenuItem>
        {options.map((option, i) => (
          <MenuItem key={i} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomPropertyOptionsSelect;
